import React from "react";
import { useTranslation } from "react-i18next";

import { SelectOptions } from "../../../assets/data/options";
import { ActivityInputTypeUnion, ActivityTypeIntersection } from "../../../store/user/types";
import { SubformProps } from "../../SubformProps";
import { InputFieldPropsUnion } from "../elements/types";
import { KeyUndefinedError, SelectFieldInternal } from "./InputField";

type ActivityFieldDescriptor = {
  [key in keyof InputFieldPropsUnion]: any;
}

type Predefined =
  | 'type'

export type ActivityInputTypeKey = keyof Omit<ActivityInputTypeUnion, Predefined>;

type ActivityFieldProps = SubformProps<ActivityTypeIntersection> & Partial<ActivityFieldDescriptor> & {
  id: ActivityInputTypeKey;
  noLabels?: boolean;
}

export const ActivityField = (props: ActivityFieldProps) : JSX.Element | null => {
  const id = props.id as ActivityInputTypeKey;

  // Hooks

  const { t } = useTranslation();

  // Building Component

  switch (id) {
    case "levelWithAdvice": {
      return (
        <SelectFieldInternal
          label={t("With advice")}
          placeholder={t("Select...")}
          options={SelectOptions().experience}
          { ...props }
        />
      );
    }
    case "levelWithAssetManagement": {
      return (
        <SelectFieldInternal
          label={t("With administration")}
          placeholder={t("Select...")}
          options={SelectOptions().experience}
          { ...props }
        />
      );
    }
    case "levelWithoutAdvice": {
      return (
        <SelectFieldInternal
          label={t("Self-Advisory/Free of charge")}
          placeholder={t("Select...")}
          options={SelectOptions().experience}
          { ...props }
        />
      );
    }
    case "transactionsPerYear": {
      return (
        <SelectFieldInternal
          label={t("Transactions/Year")}
          placeholder={t("Select...")}
          options={SelectOptions().transactionsPerYear}
          { ...props }
        />
      );
    }
    case "volumePerYear": {
      return (
        <SelectFieldInternal
          label={t("Volume/Year")}
          placeholder={t("Select...")}
          options={SelectOptions().volumePerYear}
          { ...props }
        />
      );
    }
    default: {
      KeyUndefinedError(id); // Compile-time check for unhandled cases
    }
  }

  return <></>;
}
